export class BinderySpecification {
  headband: string | undefined;
  bindStyle: string | undefined;
  cartonsPackOptionId: string | undefined;
  cartonsPackValue: number | undefined;

  constructor() {
    this.headband = undefined;
    this.bindStyle = undefined;
    this.cartonsPackOptionId = undefined;
    this.cartonsPackValue = undefined;
  }
}
